
export const DATE_FORMAT = () => "MM/dd/yyyy"